import jsonApiNormalize from '@base/json-api-normalizer.js'
import { receiveEntities } from '@actions/entity_actions.js'
import { toastSuccess } from '@actions/toast_actions.js'
import { initializeResource, stageOptions, saveOptionsComplete } from '../resource_options_slice.js' // Updated to handle generic resources

// Some types of resources can be customized, so we will want to re-initialize them
// after saving options. This array can be extended with other customizable types as needed
// This array can be extended with other customizable types as needed
const CUSTOMIZABLES = ['views', 'tables']

export const handleSaveOptionsSuccess = res => {
  return dispatch => {
    const parsedJSON = res.data
    const normalized = jsonApiNormalize(parsedJSON, { camelizeKeys: false, camelizeTypeValues: false })

    // Now iterate over the customizables and re-initialize them if any were returned from the server
    CUSTOMIZABLES.forEach(type => {
      // convert 'views' to 'View', 'tables' to 'Table', etc.
      // This ensures resourceType is set correctly for generic handling

      // convert 'views' to 'View', 'tables' to 'Table', etc.
      const resourceType = type.charAt(0).toUpperCase() + type.slice(1, -1)
      const entities = normalized[type]

      // Re-initialize some resource types using updated effective options
      if (!entities) return // No entities of this type in the response
      if (Object.keys(entities).length === 0) return // No entities of this type in the response
      Object.keys(entities).forEach(entityId => {
        const entity = entities[entityId]
        const resourceId = entity.id
        const effectiveOptions = entity?.attributes?.effective_options || {}

        dispatch(initializeResource({ resourceType, resourceId, options: effectiveOptions }))
        dispatch(stageOptions({ resourceType, resourceId, changes: effectiveOptions }))
        dispatch(saveOptionsComplete({ resourceType, resourceId, options: effectiveOptions }))
      })
    })

    // Update the entities with the normalized data
    dispatch(receiveEntities(normalized))
    dispatch(toastSuccess('Saved'))
  }
}
